interface IConfig {
  data: any[][];
  delimitator?: string;
  filename: string;
}

export const useCsv = () => {
  const arrayToCsv = (array: any[][], delimitator = ';') => {
    if (!array || !array.length) return '';
    return array.map((row) => row.join(delimitator)).join('\n');
  };

  const createBlobUrl = ({ data, delimitator = ';' }: Omit<IConfig, 'filename'>) => {
    const csvContent = arrayToCsv(data, delimitator);
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    return URL.createObjectURL(blob);
  };

  const generateCsv = ({ data, filename = 'export.csv', delimitator = ';' }: IConfig) => {
    const url = createBlobUrl({ data, delimitator });

    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return {
    arrayToCsv,
    generateCsv
  };
};
